'use client'

import { SetStateAction, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { FileUploader } from "react-drag-drop-files";
import useDrivePicker from "react-google-drive-picker";
// import styles from './upload.module.css';
import './upload.css';
import { useRouter } from "next/navigation";
// import DropboxChooser from "react-dropbox-chooser";
declare var OneDrive: any;
interface UploadProps {
    buttonText: string;
    title: string;
    image?: string;
    subtitle?: string;
    fileTypes?: string[];
    multiple?: boolean;
    onSizeLimit: () => void;
}

export default function Upload(props: UploadProps) {
    const [uploadFile, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [progress, setProgress] = useState<number>(0);
    const [openPicker, setOpenPicker] = useDrivePicker();
    const router = useRouter();
    const [error, setError] = useState<string | null>(null);
    const [isLoaderEnable, setIsLoaderEnable] = useState(false);
    
    // const fileTypes = ["PDF"];
    // const fileTypes: Array<keyof typeof mimeTypeMap> = ["PDF"];
    type FileType = "PDF" | "DOC" | "DOCX" | "XLS" | "XLSX" | "PPT" | "PPTX" | "JPG" | "JPEG" | "PNG";
    
    const mimeTypeMap = {
        PDF: "application/pdf",
        DOC: "application/msword",
        DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        XLS: "application/vnd.ms-excel",
        XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        PPT: "application/vnd.ms-powerpoint",
        PPTX: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        JPG: "image/jpeg",
        JPEG: "image/jpeg",
        PNG: "image/png",
    };
    
    // Convert fileTypes array to MIME types
    const extensionMap = {
        PDF: ".pdf",
        DOC: ".doc",
        DOCX: ".docx",
        XLS: ".xls",
        XLSX: ".xlsx",
        PPT: ".ppt",
        PPTX: ".pptx",
        JPG: ".jpg",
        JPEG: ".jpeg",
        PNG: ".png"
    };

    type ValidFileType = keyof typeof mimeTypeMap;
    const fileTypes: ValidFileType[] = props.fileTypes ? props.fileTypes.filter((type): type is ValidFileType => type in mimeTypeMap) : ["PDF"];
        

    const mimeTypes = fileTypes
        .map(type => mimeTypeMap[type])  
        .filter(Boolean)  
        .join(",");

    // Convert fileTypes array to Dropbox extensions
    const extensions = fileTypes
        .map(type => extensionMap[type])
        .filter(Boolean);

    const filter = fileTypes
        .map(type => extensionMap[type])  // Map file types to extensions
        .filter(Boolean)  // Remove undefined values
        .join(",");

    
    const image = props.image || "/images/pdf.svg";
    const subtitle = props.subtitle || "Drop PDF Here";
    const multiple = props.multiple || false;

    const fileRef = useRef();

    const handleChange = async (fileList: any) => {
        localStorage.removeItem('file_name');
        let files = new Array();
        if (fileList.length > 0) {
            files = Array.from(fileList);
        } else {
            files.push(fileList);
        }
        let totalSize = 0;
        files.forEach((file, i) => {
            totalSize += file.size;
        });
        // const files = Array.from(fileList);
        // const size = 2097152;
        const size = 20971520;
        if (totalSize >= size) {
            props.onSizeLimit();
        } else {

            setLoading(true);
            setProgress(0);
            let progressValues = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]; // Define the progress steps
            let index = 0; 
    
            let timerId = setInterval(() => {
                setProgress((prevProgress) => {
                    if (index < progressValues.length) {
                        return progressValues[index++];
                    } else {
                        clearInterval(timerId);
                        return prevProgress;
                    }
                });
            }, 100); 

            setFile(files[0] || null);

            // const reader = new FileReader();
            // reader.readAsDataURL(uploadFile!);

            const formData = new FormData();
            files.forEach((file, i) => {
                formData.append(file.name, file);
                localStorage.setItem('file_name', file.name);
            });

            try {
                const res = await fetch("/api/fileupload", {
                    method: "POST",
                    body: formData,
                });

                if (!res.ok) {
                    console.error("something went wrong, check your console.");
                    return;
                }

                const data: { fileUrl: string } = await res.json();

                clearInterval(timerId)
                setProgress(100);
                setTimeout(() => {
                    window.location.href = "/userdocument?file=" + data.fileUrl;
                }, 1000);
                // setImageUrl(data.fileUrl);
            } catch (error) {
                setLoading(false);
                console.error("something went wrong, check your console.");
            }
        }
    };

    // const handleChange = async (fileList: any) => {
    //     console.log(fileList);
        
    //     let files = new Array();
    //     if (fileList.length > 0) {
    //         files = Array.from(fileList);
    //     } else {
    //         files.push(fileList);
    //     }
    
    //     let totalSize = 0;
    //     files.forEach((file, i) => {
    //         totalSize += file.size;
    //     });
    
    //     const size = 104857600; // 20MB limit
    //     if (totalSize >= size) {
    //         props.onSizeLimit();
    //     } else {
    //         setLoading(true);
    //         setProgress(0);
    
    //         let progressValues = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]; // Define the progress steps
    //         let index = 0; 
    
    //         let timerId = setInterval(() => {
    //             setProgress((prevProgress) => {
    //                 if (index < progressValues.length) {
    //                     return progressValues[index++];
    //                 } else {
    //                     clearInterval(timerId);
    //                     return prevProgress;
    //                 }
    //             });
    //         }, 100); // Every 500ms
    
    //         setFile(files);
    
    //         const formData = new FormData();
    //         files.forEach((file, i) => {
    //             formData.append(file.name, file);
    //         });
    
    //         try {
    //             const res = await fetch("/api/fileupload", {
    //                 method: "POST",
    //                 body: formData,
    //             });
    
    //             if (!res.ok) {
    //                 console.error("Something went wrong, check your console.");
    //                 return;
    //             }
    
    //             const data: { fileUrl: string } = await res.json();
    
    //             clearInterval(timerId);
    //             setProgress(100); // Ensure it ends at 100%
    //         } catch (error) {
    //             setLoading(false);
    //             console.error("Something went wrong, check your console.");
    //         }
    //     }
    // };
    

    // const handleGoogleFileChange = async (fileList: any) => {
    //     const files = Array.from(fileList);

    //     let totalSize = 0;
    //     files.forEach((file: any) => {
    //         totalSize += file.size;
    //     });

    //     const size = 20971520; // 20 MB
    //     if (totalSize > size) {
    //         props.onSizeLimit();
    //         return;
    //     }

    //     setLoading(true);
    //     setProgress(0);

    //     const timerId = setInterval(() => {
    //         setProgress((prevProgress) => {
    //             if (prevProgress >= 100) {
    //                 clearInterval(timerId);
    //                 return 100;
    //             }
    //             return prevProgress + 20;
    //         });
    //     }, 500);

    //     const formData = new FormData();
    //     files.forEach((file: any) => {
    //         formData.append("files[]", file);
    //     });

    //     formData.append("folderId", folderData?._id ?? '');
    //     formData.append("userId", user?._id);

    //     try {
    //         const res = await fetch("/api/upload/google-drive-upload", {
    //             method: "POST",
    //             body: formData,
    //         });
    //         const resdata = await res.json();

            
    //     } catch (error) {
    //         console.error("Something went wrong:", error);
    //     } finally {
    //         clearInterval(timerId);
    //         setLoading(false);
    //     }
    // };

    const getAccessToken = async () => {
        const tokenData = localStorage.getItem("googleDriveTokens");

        if (tokenData) {
            const tokenObject = JSON.parse(tokenData);

            // Check if the access token has expired
            const currentTime = Date.now();
            if (currentTime < tokenObject.expiry_date) {
                return tokenObject.access_token;
            } else {
                const newToken = await fetchNewAccessToken();
                return newToken ? newToken : null;
            }
        } else {
            const newToken = await fetchNewAccessToken();
            return newToken ? newToken : null;
        }
    };

    const loadGooglePicker = () => {
        if (!window.gapi) {
            console.error("Google API not loaded.");
            return;
        }
    
        window.gapi.load('picker', () => {
            console.log("Google Picker API loaded.");
        });
    };

    useEffect(() => {
        // Load the Google Picker API
        loadGooglePicker();
    }, []);


    // Ensure mimeTypes is an array
    const mimeTypesArray = Array.isArray(mimeTypes) ? mimeTypes : [
        'application/pdf', // PDF files
        'application/vnd.google-apps.document', // Google Docs
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word documents
        'text/plain', // Plain text files
    ];

    
    const handleGoogleDriveAuth = async () => {
        setIsLoaderEnable(true);
        document.body.classList.add('overflow-hidden');
    
        // Fetch the access token
        const accessToken = await getAccessToken();
    
        if (accessToken) {
            setIsLoaderEnable(false);
    
            // Load the Google Picker API
            if (!window.google) {
                console.error("Google API not loaded.");
                return;
            }
    
            // Create and render the Google Picker
            const googleDriveDeveloperKey = process.env.NEXT_PUBLIC_GOOGLEDRIVE_DEVELOPER_KEY as string;
            const googleDriveClientId = process.env.NEXT_PUBLIC_GOOGLEDRIVE_CLIENT_ID as string;
            const picker = new window.google.picker.PickerBuilder()
                .setOAuthToken(accessToken) // Set the OAuth token
                .setDeveloperKey(googleDriveDeveloperKey) // Set the developer key
                .setAppId(googleDriveClientId) // Set the app ID
                .setCallback(async (data) => {
                    if (data.action === window.google.picker.Action.CANCEL) {
                        setIsLoaderEnable(false);
                        document.body.classList.remove('overflow-hidden');
                        console.log("User clicked cancel/close button");
                    } else if (data.action === window.google.picker.Action.PICKED) {
                        console.log("Selected files from Google Drive:", data.docs);
                        setIsLoaderEnable(true);
    
                        // Process the selected files
                        // const fileBlobs = await Promise.all(
                        //     data.docs.map(async (doc) => {
                        //         try {
                        //             const isGoogleDocsFile = doc.mimeType.includes("application/vnd.google-apps");
                        //             const downloadUrl = isGoogleDocsFile
                        //                 ? `https://www.googleapis.com/drive/v3/files/${doc.id}/export?mimeType=application/vnd.openxmlformats-officedocument.wordprocessingml.document`
                        //                 : `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`;
    
                        //             const response = await fetch(downloadUrl, {
                        //                 headers: {
                        //                     Authorization: `Bearer ${accessToken}`,
                        //                 },
                        //             });
    
                        //             if (!response.ok) {
                        //                 throw new Error(`Failed to fetch file: ${response.statusText}`);
                        //             }
    
                        //             const blob = await response.blob();
                        //             return new File([blob], doc.name, { type: blob.type });
                        //         } catch (error) {
                        //             console.error("Error fetching file:", error.message);
                        //             return null;
                        //         }
                        //     })
                        // );

                        const fileBlobs = await Promise.all(
                            (data.docs || []).map(async (doc) => {  // Fallback to empty array if `docs` is undefined
                                try {
                                    const isGoogleDocsFile = doc.mimeType ? doc.mimeType.includes("application/vnd.google-apps") : false;
                                    const downloadUrl = isGoogleDocsFile
                                        ? `https://www.googleapis.com/drive/v3/files/${doc.id}/export?mimeType=application/vnd.openxmlformats-officedocument.wordprocessingml.document`
                                        : `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`;
                        
                                    const response = await fetch(downloadUrl, {
                                        headers: {
                                            Authorization: `Bearer ${accessToken}`,
                                        },
                                    });
                        
                                    if (!response.ok) {
                                        throw new Error(`Failed to fetch file: ${response.statusText}`);
                                    }
                        
                                    const blob = await response.blob();
                                    return new File(
                                        [blob], 
                                        doc.name as string,  // Assertion
                                        { 
                                            type: blob.type as string  // Assertion
                                        }
                                    );
                                } catch (error) {
                                    console.error("Error fetching file:", error instanceof Error ? error.message : String(error));
                                    return null;
                                }
                            })
                        );
    
                        // Filter out null files in case of errors
                        const validFiles = fileBlobs.filter((file) => file !== null);
    
                        // Upload valid files to your backend
                        if (validFiles.length > 0) {
                            setIsLoaderEnable(false);
                            await handleChange(validFiles); // Upload files
                        }
                    }
                })
                .addView(new window.google.picker.DocsView(window.google.picker.ViewId.DOCS)
                    .setIncludeFolders(true)
                    .setSelectFolderEnabled(false)
                    .setMimeTypes(mimeTypesArray.join(','))) // Set allowed MIME types
                .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED) // Enable multi-select
                .build(); // <-- Add semicolon here
    
            // Render the picker
            picker.setVisible(true); // <-- Now this line works correctly
        } else {
            document.body.classList.remove('overflow-hidden');
            setIsLoaderEnable(false);
            console.error("Unable to fetch a valid access token.");
        }
    };
    
    
    const fetchNewAccessToken = async () => {
        try {
            const res = await fetch("/api/auth/google/?screen=home", {
                method: "GET",
            });

            if (res.status === 200) {
                const resData = await res.json();

                // Assuming the API returns a new token object
                if (resData.access_token && resData.expiry_date) {
                    const newTokenData = {
                        access_token: resData.access_token,
                        expiry_date: resData.expiry_date,
                    };

                    // Save the new token to localStorage
                    localStorage.setItem("googleDriveTokens", JSON.stringify(newTokenData));

                    return newTokenData.access_token; // Return the new access token
                } else if (resData.url) {
                    // Redirect for re-authentication
                    window.location.href = resData.url;
                } else {
                    console.error("Unexpected response structure from the API.");
                }
            } else {
                console.error("Failed to fetch new access token. Status:", res.status);
            }
        } catch (error) {
            console.error("Error fetching new access token:", error);
        } 

        return null; // Return null if unable to fetch a new token
    };
    
    
    useEffect(() => {
        // Get tokens from the query string
        const urlParams = new URLSearchParams(window.location.search);
        const access_token = urlParams.get('access_token');
        const refresh_token = urlParams.get('refresh_token');
        const expiry_date = urlParams.get('expiry_date');
        const token_type = urlParams.get('token_type');
        const scope = "https://www.googleapis.com/auth/drive.file";

        if (access_token) {
            const tokenData = { access_token, refresh_token, expiry_date, token_type, scope };
            localStorage.setItem('googleDriveTokens', JSON.stringify(tokenData));
            window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}`;
        }
    }, [router]);

    useEffect(() => {
        if (!(window as any).Dropbox) {
            const script = document.createElement("script");
            const dropBoxKey = process.env.NEXT_PUBLIC_DROPBOX_KEY as string;
            script.src = "https://www.dropbox.com/static/api/2/dropins.js";
            script.type = "text/javascript";
            script.id = "dropboxjs";
            script.setAttribute("data-app-key", dropBoxKey); 
            document.body.appendChild(script);
        }
    }, []);

    const handleDropboxChooser = async () => {
        if (!(window as any).Dropbox) {
            console.error("Dropbox SDK is not loaded yet.");
            return;
        }
    
        (window as any).Dropbox.choose({
            success: async function (files: any) {
                console.log("Selected files from Dropbox:", files);
    
                if (files && files.length > 0) {
                    const fileBlobs = await Promise.all(
                        files.map(async (doc: any) => {
                            try {
                                // Ensure the URL forces a binary download
                                const downloadUrl = doc.link.includes("?") ? doc.link + "&dl=1" : doc.link + "?dl=1";
    
                                // Fetch the file from Dropbox
                                const response = await fetch(downloadUrl);
                                console.log("Response Headers:", response.headers);
    
                                if (!response.ok) {
                                    throw new Error(`Failed to fetch file: ${response.statusText}`);
                                }
    
                                const blob = await response.blob();
    
                                // Convert Blob to File object
                                return new File([blob], doc.name, { type: blob.type });
                            } catch (error: any) {
                                console.error("Error fetching file:", error.message);
                                return null;
                            }
                        })
                    );
    
                    // Filter out null files in case of errors
                    const validFiles = fileBlobs.filter((file) => file !== null);
    
                    // Upload valid files to your backend
                    if (validFiles.length > 0) {
                        await handleChange(validFiles);
                    }
                }
            },
            cancel: function () {
                console.log("Dropbox Chooser was closed.");
            },
            linkType: "direct",
            multiselect: false,
            extensions: extensions,
        });
    };
    
    const handleOneDrivePicker = () => {
        const odOptions = {
            clientId: process.env.NEXT_PUBLIC_ONEDRIVE_KEY,
            action: "share",
            multiSelect: false,
            advanced: {
                redirectUri: `${process.env.NEXT_PUBLIC_BASE_URL}/dashboard/onedrive-callback`,
                filter: filter,
            },
            success: async function (files: any) {
                setIsLoaderEnable(true);
                if (files && files.value.length > 0) {
                    try {
                        const formData = new FormData();
                        for (const file of files.value) {
                            const response = await fetch(file["@microsoft.graph.downloadUrl"]);
                            const blob = await response.blob();
                            const fileObject = new File([blob], file.name, { type: file.file.mimeType });
                            formData.append("files", fileObject);
                            setIsLoaderEnable(false);
                            handleChange(fileObject);
                            console.log(formData);
                            
                        }
                        console.log(formData);
                        
                        // handleChange(formData);
                    } catch (err: any) {
                        console.error("Upload failed:", err.message);
                    }
                } else {
                    alert("No file selected.");
                }
            },
            cancel: () => {
                console.log("File picker closed.");
            },
            error: (e: any) => {

            },
        };

        // Open the OneDrive picker
        OneDrive.open(odOptions);
    };

    return (
        <>
            {(isLoaderEnable) && 
                <div className="data-loader-wrapper">
                    <div className="data-loader"></div>
                </div>
            }
            {/* <div className="col-lg-6">
                <div className="hero__box-wrapper box-shadow ">
                    <h2 className="sub-heading text-center mb-200">{props.title}</h2>
                    <FileUploader multiple={multiple} handleChange={handleChange} hoverTitle=" " name="file" types={fileTypes} dropMessageStyle={{ backgroundColor: 'transparent', border: 'none' }}
                        style={{ innerWidth: "50%" }} ref={fileRef}>
                        <div className="hero__box d-flex flex-column align-items-center justify-center">
                            <img src={image} alt="pdf" className="above-the-fold" width="132" height="132" />
                            <p>{subtitle}</p>
                            <div className="md:flex flex-col">
                                <span className="flex items-center justify-center space-x-2">
                                    <span className="h-px bg-gray-400 w-14"></span>
                                    <p className="fs-3">or</p>
                                    <span className="h-px bg-gray-400 w-14"></span>
                                </span>
                            </div>
                            <button className="mybtn mybtn--primary">{props.buttonText}</button>
                        </div>
                        <div className="hero__media-box d-flex justify-content-center gap-2">
                            <a href="#">
                                <div className="hero__box-icon box-shadow">
                                    <img className="img-fluid" src="/img/box-icon.svg" alt="drive-icon" />
                                </div>
                            </a>
                            <a href="#">
                                <div className="hero__box-icon box-shadow">
                                    <img className="img-fluid" src="/img/sky-icon.svg" alt="drive-icon" />
                                </div>
                            </a>
                            <a href="#">
                                <div className="hero__box-icon box-shadow">
                                    <img className="img-fluid" src="/img/drive-icon.svg" alt="drive-icon" />
                                </div>
                            </a>
                            <a href="#">
                                <div className="hero__box-icon box-shadow">
                                    <img className="img-fluid" src="/img/blue-sky-icon.svg" alt="drive-icon" />
                                </div>
                            </a>
                        </div>
                    </FileUploader>
                </div>

            </div> */}



            <h2 className="sub-heading text-center mb-200">{props.title}</h2>
            <FileUploader multiple={multiple} handleChange={handleChange} hoverTitle=" " className='hekk' name="file" types={fileTypes} dropMessageStyle={{ backgroundColor: '#d3e3fd', border: 'none', }
            }
                style={{ innerWidth: "50%" }} ref={fileRef}>
                <div className="hero__box d-flex flex-column align-items-center">
                    <img src={image} alt="pdf" className="above-the-fold" width="132" height="132" />
                    <p className="m-0">{subtitle}</p>
                    <div className="md:flex">
                        <span className="flex items-center justify-center gap-2 space-x-2">
                            <span className="h-px bg-gray-400 w-14"></span>
                            <p className="md:text-3xl text-xl m-0 p-0 lh-sm">or</p>
                            <span className="h-px bg-gray-400 w-14"></span>
                        </span>
                    </div>
                    <button className="mybtn mybtn--primary py-2">{props.buttonText}</button>
                </div>

            </FileUploader>
            <div className="hero__media-box d-flex justify-content-center gap-2">
                <button onClick={handleDropboxChooser}>
                    <div className="hero__box-icon box-shadow">
                        <img className="img-fluid" src="/img/box-icon.svg" alt="drive-icon" />
                    </div>
                </button>
                {/* <a href="#">
                    <div className="hero__box-icon box-shadow">
                        <img className="img-fluid" src="/img/sky-icon.svg" alt="drive-icon" />
                    </div>
                </a> */}
                <button onClick={handleGoogleDriveAuth}>
                    <div className="hero__box-icon box-shadow">
                        <img className="img-fluid" src="/img/drive-icon.svg" alt="drive-icon" />
                    </div>
                </button>
                <button onClick={handleOneDrivePicker}>
                    <div className="hero__box-icon box-shadow">
                        <img className="img-fluid" src="/img/blue-sky-icon.svg" alt="drive-icon" />
                    </div>
                </button>
            </div>


            {
                loading ? (
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-5/6 md:w-2/5 my-6 mx-auto">
                                {/*content*/}
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    {/*header*/}
                                    <div className="flex items-center justify-between p-4 px-5 border-b border-solid border-blueGray-200 rounded-t">
                                        <h3 className="text-lg md:text-3xl font-semibold mb-0">
                                            Processing document...
                                        </h3>
                                    </div>
                                    {/*body*/}
                                    <div className="relative px-5 flex-row w-full text-center justify-around">
                                        {/* <div className="mt-10 w-full flex text-center items-center justify-center">
                                        <svg className="animate-spin w-10 h-10 fill-slate-800" viewBox="3 3 18 18">
                                            <path className="opacity-20" d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z">
                                            </path>
                                            <path d="M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z">
                                            </path>
                                        </svg>
                                         </div> */}
                                        <div className="mt-3 w-full flex text-base md:text-2xl mb-10">
                                            <span className="text-body-tertiary">Please wait while our engine does the work for you.</span>
                                        </div>
                                        <div className="loading-bar animate text-center text-white text-lg align-middle">
                                            <span className="h-8" style={{ width: progress + "%" }}>{progress} %</span>
                                        </div>

                                    </div>
                                    <div className="d-flex justify-content-end pb-7 pe-5">
                                        <div>
                                            <img className="img-fluid" src="/img/progress-bar.svg" alt="drive-icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-50 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null
            }
        </>
    );
}